import React, { useContext, useMemo, useState } from "react";

import * as styles from "./countrySelectionBanner.module.less";
import { Button } from "../../Button";

import t from "../../../lib/translate";
import GeneralPageContext from "../../../templates/GeneralPageContext";
import { useInput } from "../../../lib/hooks/formHooks";
import { isBrowser } from "../../../lib/helper/variables";

const BANNER_SHOWN_KEY = "regionBannerShown";

export function CountrySelectionBanner() {
    const { locale: currentLanguage, localeVariants } =
        useContext(GeneralPageContext);

    const [show, setShow] = useState(true);
    const [disabled, setDisabled] = useState(true);

    let clientLanguage = "";

    if (isBrowser) {
        clientLanguage = window.navigator.language.substring(0, 2);
    }

    const { value, bind } = useInput("none");

    const to = useMemo(
        () => localeVariants.find(({ locale }) => locale === value)?.url,
        [localeVariants, value]
    );

    if (isBrowser) {
        const bannerShown = window.localStorage.getItem(BANNER_SHOWN_KEY);

        if (disabled && !bannerShown) {
            setDisabled(false);
        }
    }

    if (disabled || !show || clientLanguage === currentLanguage) {
        return null;
    }

    return (
        <div
            className={styles.countrySelectionBanner}
            data-datocms-noindex={true}
        >
            <div className={styles.content}>
                <div className={styles.text}>
                    <p>{t("javascript.region.banner.caption")}</p>
                </div>

                <div className={styles.input}>
                    <div className={styles.countrySelector}>
                        <select
                            type={"select"}
                            placeholder={t(
                                "javascript.region.selector.caption-upper"
                            )}
                            {...bind}
                        >
                            <option value={"none"}>
                                {t("javascript.region.selector.caption")}
                            </option>

                            {localeVariants.map(({ locale }) => (
                                <option
                                    key={`countrySelect-langOption-${locale}`}
                                    className={styles.langSelector}
                                    value={locale}
                                >
                                    {t(`lang-nav.option-${locale}.label`)}
                                </option>
                            ))}
                        </select>

                        <label>
                            {t("javascript.region.selector.caption-upper")}
                        </label>
                    </div>

                    {to && (
                        <Button
                            renderAs="link"
                            to={to}
                            type={"cta"}
                            className={styles.continueButton}
                            onClick={() => {
                                window.localStorage.setItem(
                                    BANNER_SHOWN_KEY,
                                    true
                                );
                            }}
                        >
                            {t("javascript.region.selector.button")}
                        </Button>
                    )}
                </div>

                <div className={styles.closeButton}>
                    <Button
                        className={styles.closeButtonIcon}
                        type={"secondary"}
                        iconPosition={"right"}
                        icon={"close"}
                        aria-label={t("navigation.button.close")}
                        onClick={() => {
                            window.localStorage.setItem(BANNER_SHOWN_KEY, true);
                            setShow(!show);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
